import Vue from 'vue'
import VModal from 'vue-js-modal'
import VTooltip from 'v-tooltip'
import VueKonva from 'vue-konva'
// Import component
import Loading from 'vue-loading-overlay'
// CSS not needed for vue-loading-overlay v2.x
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

import Notifications from 'vue-notification'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

import SurveyApp from './SurveyApp.vue'

import store from './store'

Vue.use(Loading)
Vue.use(CoolLightBox)
Vue.use(Notifications)
Vue.use(VueKonva)
Vue.use(VTooltip)
Vue.use(VModal)
Vue.use(VueSweetalert2)

Vue.filter('capitalize', (value) => {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('get_text', function (value) {
  try {
    return value.split('|')[0]
  } catch (e) {
    return null
  }
})

Vue.filter('get_tags', function (value) {
  try {
    return value.split('|')[1]
  } catch (e) {
    return null
  }
})


const app = new Vue({
  store,
  components: {
    survey: SurveyApp,
  },
  created() {
    this.$store.dispatch('getCurrentUser')
  },
})

app.$mount('#survey_app')
